import { serviceMaker } from "..";
import { IPagination } from "../../data/AppInterface";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";
import { paginationParams, toQueryString } from "../../utils/QueryString";

interface ICreditGrantPayload {
  firm_id: string;
  credit_type: string;
  credits: number;
  note: string | null;
}

export const GET_FIRM_CREDIT_BALANCE = (firmId: string) =>
  serviceMaker(
    API_ENDPOINTS.get_firm_credit_balance.url(firmId),
    API_ENDPOINTS.get_firm_credit_balance.method
  );

export const GET_FIRM_CREDIT_LEDGER = (
  firmId: string,
  pagination: IPagination,
  creditType: string | null
) =>
  serviceMaker(
    API_ENDPOINTS.get_firm_credit_ledger.url(firmId) +
      toQueryString({ ...paginationParams(pagination), credit_type: creditType }),
    API_ENDPOINTS.get_firm_credit_ledger.method
  );

export const GRANT_CREDITS = (payload: ICreditGrantPayload) =>
  serviceMaker(
    API_ENDPOINTS.grant_credits.url,
    API_ENDPOINTS.grant_credits.method,
    payload
  );
